// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import GifOutlinedSvg from "@fishx/icons-svg/es/asn/GifOutlined";
import FishxIcon from '../components/FishxIcon';

var GifOutlined = function GifOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: GifOutlinedSvg
  }));
};

GifOutlined.displayName = 'GifOutlined';
export default React.forwardRef(GifOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/GifOutlined.js
// module id = 2866
// module chunks = 0